/**
 * @hidden
 */
var isServerRendering = function () {
  return typeof window === 'undefined';
};
export { isServerRendering };